import classNames from 'clsx';
import React from 'react';
import DropdownMenu from '../DropdownMenu';
import withI18next from '~/../hocs/_withI18next';
import Config, { keyConfig } from '~/config';
import { slugs } from '~/utils';
import IconFacebook from '~/components/svg/icon-facebook.svg';
import IconTwitter from '~/components/svg/icon-twitter.svg';
import IconPinterest from '~/components/svg/icon-pinterest.svg';
import themeVariables from '~/shared/themeVariables';

const SHARE_SERVICE = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
};

const shareServiceIcons = {
  [SHARE_SERVICE.FACEBOOK]: <IconFacebook />,
  [SHARE_SERVICE.TWITTER]: <IconTwitter />,
  [SHARE_SERVICE.PINTEREST]: <IconPinterest />,
};

const socialBaseUrls = {
  [SHARE_SERVICE.FACEBOOK]: 'https://facebook.com/sharer/sharer.php?u=',
  [SHARE_SERVICE.TWITTER]: 'https://twitter.com/intent/tweet/?text=&url=',
  [SHARE_SERVICE.PINTEREST]: 'https://www.pinterest.com/pin-builder/?url=',
};
const shareServiceIconsIllust = {
  [SHARE_SERVICE.FACEBOOK]: `${Config.staticPrefix}/static/assets/svg/icon-facebook.svg`,
  [SHARE_SERVICE.TWITTER]: `${Config.staticPrefix}/static/assets/svg/icon-twitter.svg`,
  [SHARE_SERVICE.PINTEREST]: `${Config.staticPrefix}/static/assets/svg/icon-pinterest.svg`,
};
@withI18next()
class ButtonSocialShare extends React.Component {
  onSocialShare = (serviceName) => {
    const socialBaseUrl = socialBaseUrls[serviceName];
    const { lng, photo } = this.props;
    const photoTitle = Config.getTitleByLanguage(photo.title, lng);
    const slugTitle = slugs.makeSlug(photoTitle, {
      lang: lng,
    });

    // const { protocol, host } = window.location;
    const imageUrl = `${Config.getSiteURL()}/${keyConfig.get(
      'route_detail_page',
    )}/${photo.id}/${slugTitle}`;
    const shareUrl = `${socialBaseUrl}${imageUrl}`;

    if (serviceName === SHARE_SERVICE.PINTEREST) {
      window.open(
        `${shareUrl}&media=${photo.path}`,
        'share',
        `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
          window.innerWidth / 2 - 225
        }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
      );
    } else {
      window.open(
        shareUrl,
        'share',
        `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
          window.innerWidth / 2 - 225
        }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
      );
    }
  };

  noPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  renderButtonShare = () => (
    <div className="icon_share_folder_container">
      <img
        className="img-icon-share-folder-org"
        src={`${Config.staticPrefix}/static/assets/svg/icon_share_org_thumbnail.svg`}
        onClick={this.noPropagation}
      />
      <img
        className="img-icon-share-folder-active"
        src={`${Config.staticPrefix}/static/assets/svg/icon_share_active_thumbnail.svg`}
        onClick={this.noPropagation}
      />
      <style jsx>
        {`
          .icon_share_folder_container {
            background: #ffffff;
            display: ${Config.isIllustAC() ? 'none' : 'flex'};
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 32px;
            height: 32px;
            border-radius: 4px;
          }
          .icon_share_folder_container:hover {
            background: ${themeVariables.color.primary};
          }
          .icon_share_folder_container:hover .img-icon-share-folder-org {
            display: none;
          }
          .icon_share_folder_container:hover .img-icon-share-folder-active {
            display: block;
          }
          .img-icon-share-folder-active {
            display: none;
          }
        `}
      </style>
    </div>
  );
  handleClickPinterest = () => {
    const { description, photo } = this.props;
    let imageUrl = photo.path;
    /* eslint-disable */
    PinUtils.pinOne({
      url: window.location.href,
      media: imageUrl,
      description: description,
    });
  };
  render() {
    const { isFromDownloadPage } = this.props;

    const shareActions = [
      SHARE_SERVICE.PINTEREST,
      SHARE_SERVICE.TWITTER,
      SHARE_SERVICE.FACEBOOK,
    ].map((serviceName) => {
      const shareButtonClassName = classNames(
        'share-button',
        `btn-${serviceName}`,
      );
      return (
        <div
          key={serviceName}
          className={shareButtonClassName}
          onClick={(e) => {
            this.noPropagation(e);
            if (serviceName === SHARE_SERVICE.PINTEREST) {
              this.handleClickPinterest();
            } else {
              this.onSocialShare(serviceName);
            }
          }}
        >
          {Config.isIllustAC() ? (
            <div className="btn-sns-share">
              <img
                src={shareServiceIconsIllust[serviceName]}
                height={'32px'}
                width={'32px'}
                alt="icon-service"
              />
              <style jsx>{`
                .btn-sns-share {
                  width: 32px;
                  height: 32px;
                  border-radius: 9999px;
                  overflow: hidden;
                  margin: 0 4px;
                  display: flex;
                  justify-content: center;
                  flex-direction: row;
                  align-items: center;
                  cursor: pointer;
                }
                .btn-sns-share:hover {
                  opacity: 0.8;
                }
              `}</style>
            </div>
          ) : (
            shareServiceIcons[serviceName]
          )}
        </div>
      );
    });

    if (Config.isIllustAC())
      return (
        <div className="share-button-illust">
          {shareActions}
          <style jsx>
            {`
              .share-button-illust {
                display: flex;
                position: absolute;
                ${isFromDownloadPage
                  ? ``
                  : `top: 11px;
                  left: 12px;`}
              }
            `}
          </style>
        </div>
      );

    return (
      <DropdownMenu
        className="button-social-share"
        position="left"
        header={this.renderButtonShare()}
      >
        <div className="dropdown-left-options">{shareActions}</div>
        <style jsx global>
          {`
            .button-social-share {
              display: flex;
              justify-content: center;
            }
            .dropdown-left-options {
              display: flex;
              gap: 4px;
              padding: 4px;
              border-radius: 4px;
            }
            .share-button:hover {
              opacity: 0.8;
            }
          `}
        </style>
      </DropdownMenu>
    );
  }
}

export default ButtonSocialShare;
